import { computed } from 'vue'
import type { FeaturesType } from '@/interfaces'
import { useCurrentProperty } from './use-current-property'

function isInteractive(feature?: FeaturesType) {
  return feature?.enabled === true && feature?.visible === true
}

// Property-level flags. Unit-level flags: see utils/unit-features.ts.
export function useFeaturesConfig() {
  const { currentProperty } = useCurrentProperty()

  const isAwayModeDisabled = computed(() => {
    return currentProperty.value?.features.away_mode?.enabled === false
  })

  const isAwayModeVisible = computed(() => {
    return currentProperty.value?.features.away_mode?.visible === true
  })

  const isEnergyOptimisationsDisabled = computed(() => {
    return (
      currentProperty.value?.features.energy_optimisations?.enabled === false
    )
  })

  const isEnergyOptimisationsVisible = computed(() => {
    return (
      currentProperty.value?.features.energy_optimisations?.visible === true
    )
  })

  const isHotWaterOptimisationsDisabled = computed(() => {
    return (
      currentProperty.value?.features.hot_water_optimisations?.enabled === false
    )
  })

  const isHotWaterOptimisationsVisible = computed(() => {
    return (
      currentProperty.value?.features.hot_water_optimisations?.visible === true
    )
  })

  const isLoadsheddingAwareInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.loadshedding_aware)
  )

  const isLoadsheddingAwareVisible = computed(() => {
    return currentProperty.value?.features.loadshedding_aware?.visible === true
  })

  const isWifiInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.wifi)
  )

  const isSupportLinkInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.show_support_link)
  )

  const isGeyserHeatingInfoInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.geyser_heating_info)
  )

  const isGeyserSetpointInfoInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.geyser_setpoint_info)
  )

  const isNewPeakShieldInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.new_peak_shield)
  )

  const isMduSubscriptionInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.mdu_subscription)
  )

  const isSduSubscriptionInteractive = computed(() =>
    isInteractive(currentProperty.value?.features.sdu_subscription)
  )

  return {
    isEnergyOptimisationsDisabled,
    isEnergyOptimisationsVisible,
    isHotWaterOptimisationsDisabled,
    isHotWaterOptimisationsVisible,
    isAwayModeDisabled,
    isAwayModeVisible,
    isLoadsheddingAwareInteractive,
    isLoadsheddingAwareVisible,
    isWifiInteractive,
    isSupportLinkInteractive,
    isGeyserHeatingInfoInteractive,
    isGeyserSetpointInfoInteractive,
    isNewPeakShieldInteractive,
    isMduSubscriptionInteractive,
    isSduSubscriptionInteractive
  }
}
